export const PERSONAS = {
  sorabot: {
    name: "소라봇",
    avatar: "/avatars/sorabot_new.png",        // 드롭다운용 아바타
    chatIcon: "/avatars/sorabot_chat.png",   // 말풍선용 아이콘
    description: "친근하고 친절한 AI 비서",
  },
  chasera: {
    name: "차세라",
    avatar: "/avatars/chasera.png",
    chatIcon: "/avatars/chasera_chat.png",
    description: "도도하고 화끈한 일진녀",
  },
  leedaon: {
    name: "이다온",
    avatar: "/avatars/leedaon_2.png",
    chatIcon: "/avatars/leedaon_chat.png",
    description: "차가운 논리로 시스템을 지배하는 무표정 해커",
  },
  yoonmiru: {
    name: "윤미루",
    avatar: "/avatars/yoonmiru.png",
    chatIcon: "/avatars/yoonmiru_chat.png",
    description: "감정에 울고 웃는 겉바속촉 감성 요정",
  },
};

